import React from 'react'
import { Modal } from '@clickcease/cc-client-components-lib'

import { useTranslation } from 'react-i18next'
import { BzSetupInner } from 'Features/bzSetupPopup/BzSetupInner'

interface BzSetupPopupProps {
  isOpen?: boolean
  onOpenChange: (a: boolean) => void
  domainAddress: string
}

export const BzSetupPopup = ({ isOpen, onOpenChange, domainAddress }: BzSetupPopupProps) => {
  const { t } = useTranslation('domainManagement')

  return (
    <Modal
      id={'bz-setup-modal'}
      title={t('bzSetupPopup.title')}
      isOpen={isOpen}
      onOpenChange={onOpenChange}
    >
      <BzSetupInner onOpenChange={onOpenChange} domainAddress={domainAddress} />
    </Modal>
  )
}
